// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shuckle: PokeData = {
  "id": 213,
  "name": "shuckle",
  "height": 6,
  "weight": 205,
  "base_experience": 177,
  "types": [
    PokeType.BUG,
    PokeType.ROCK
  ],
  "api_moves": [
    "wrap",
    "rock-throw",
    "withdraw",
    "bide",
    "constrict",
    "rest",
    "rock-slide",
    "rollout",
    "safeguard",
    "encore",
    "power-trick",
    "gastro-acid",
    "stone-edge",
    "bug-bite",
    "guard-split",
    "power-split",
    "shell-smash",
    "struggle-bug",
    "sticky-web"
  ],
  "moves": [
    "rock-throw",
    "rock-slide",
    "bug-bite",
    "sticky-web",
    "stone-crush",
    "power-siphon",
    "rock-smash",
    "signal-spam",
    "pin-missile",
    "seismic-toss",
    "infest",
    "heal-order",
    "lunge"
  ],
  "evolution_chain": {
    "id": 107,
    "item": null,
    "species": [
      {
        "name": "shuckle",
        "order": 243,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 250,
    "speed": 10,
    "ability_power": 20
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
